export const INTERNAL_ROUTES = {
  HOME: "/",
  UNAUTHORIZED: "/unauthorized",
  LOGIN: "/login",
} as const;

export const PUBLIC_ROUTES: string[] = [INTERNAL_ROUTES.LOGIN, INTERNAL_ROUTES.UNAUTHORIZED];

export const TRUSTED_DOMAIN_ADMIN_ROUTES: Record<string, string> = {} as const;
